/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from "react";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import EmojiPicker from "emoji-picker-react";

//MUI
import styled from "@emotion/styled";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Button from '@mui/material/Button';
import Box from "@mui/material/Box";

//icons
import { ReactComponent as PublishIcon } from "../../assets/publish_icon.svg";
import { ReactComponent as UncheckedIcon } from "../../assets/unchecked.svg";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";
import { ReactComponent as ClockIcon } from "../../assets/clock_icon.svg";
import { ReactComponent as FacebookIcon } from "../../assets/facebook_icon.svg";
import { ReactComponent as InstagramIcon } from "../../assets/instagram_icon.svg";
import { ReactComponent as DropDownIcon } from "../../assets/dropdown_icon.svg";
import {ReactComponent as YoutubeIcon} from "../../assets/youtube.svg";

//components
import PreviewImageVideo from "./PreviewImageVideo";
import CustomButton from "../Common/CustomButton";
import CustomTextField from "../Common/CustomTextField";
import FinalConfirmation from "./FinalConfirmation";
import MessageDialog from "./MessageDialog";
import ThumbnailSelection from "./ThumbnailSelection";
import AutoCompleteMultiPlatformSelect from "../Common/AutoComplete/AutoCompleteMultiPlatformSelect";
import AntSwitch from "../Common/AntSwitch";

//utils
import { uploadGeneratedThumbnail } from "../../utils/uploadThumbnail";
//assets
import DefaultThumbnail from "../../assets/images/thumbnail1.png";

//customHooks
import useWindowDimensions from "../../customHooks/useWindowDimensions";

//apis
import { publishContent,getYoutubeAuth,publishYoutubeContent,getYoutubeAuthStatus } from "../../apis/taskManagement";

//context
import { AlertContext } from "../../contexts/AlertContext";

const Container = styled("div")(({ theme, content, schedule }) => ({
  width: "100%",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "relative",
  "& .top_section": {
    "& .text_style": {
      fontSize: "14px",
      fontWeight: "500",
    },
    "& .heading": {
      margin: "0rem 1rem",
      padding: "0.75rem 0",
      borderBottom: "1px solid #EAEAEA",
      "& .text_style": {
        fontWeight: "700",
        fontSize: "18px",
      },
    },
    "& .content_info": {
      padding: "0.5rem 0 0 0",
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      height:'50vh',
      overflowY: "scroll",
      "&::-webkit-scrollbar": {
        width: "0.4em",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "gray",
        borderRadius: "30px",
      },
      "& .page_info": {
        padding: "0 1rem",
        marginBottom: "0.25rem",
        "& .page_text": {
          color: "#303030",
          fontWeight: "500",
        },
      },
      "& .platform_select":{
        padding: "0 1rem",
      },
      "& .MuiAccordion-root:before":{
          height:"0px",
      },
      "& .accordion_container": {
        margin: "0 1rem",
        // borderRadius: "8px",
        boxShadow:"none",
        "& .summary": {
          minHeight:"30px",
          backgroundColor:"#EDEDED",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          "& .MuiTypography-root":{
            fontSize:"16px",
            [theme.breakpoints.down("xl")]: {
              fontSize: "14px",
            },
            fontWeight:"500",
          },
          "& .MuiAccordionSummary-content":{
            margin:"4px 0px"
          },
          "& .Mui-expanded": {
            transform: "none",
          },
        },
        ".MuiAccordionDetails-root":{
          backgroundColor:"#F5F5F5",
          padding:"8px 16px",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
        },
        "& .acr_btn_container":{
          marginBottom:"0.5rem",
          "& .acr_btn":{
              textTransform:"none",
              marginRight:"0.5rem",
              padding:"0.25rem 0.5rem",
            },
            "& .acr_btn.selected": {
              backgroundColor: "#C2D1FF",
            },
        },
        "& .caption_container": {
          display: "flex",
          flexDirection: "column",
          "& .MuiTextField-root":{
            backgroundColor:"#FFFFFF",
          },
          "& textarea": {
            border: "1px solid #b3b3b3",
            padding: "0.3rem 0.6rem",
            borderRadius: "4px",
            fontFamily: theme.typography.fontFamily,
            "&:focus": {
              outlineColor: "#00A0E3",
            },
          },
        },
      },
      "& .schedulerAccordion": {
        margin: "0 1rem",
        // borderRadius: "8px",
        boxShadow:"none",
        "& .summary": {
          ...(schedule
            ? {
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }
            : {
                borderRadius: "8px",
              }),
          minHeight:"30px",
          backgroundColor:"#EDEDED",
          "& .MuiTypography-root":{
            fontSize:"16px",
            [theme.breakpoints.down("xl")]: {
              fontSize: "14px",
            },
            fontWeight:"500",
          },
          "& .MuiAccordionSummary-content":{
            margin:"4px 0px"
          },
          "& .Mui-expanded": {
            transform: "none",
          },
        },
        ".MuiAccordionDetails-root":{
          backgroundColor:"#F5F5F5",
          padding:"8px 16px",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
        },
        "& .scheduler_container":{
          display:"flex",
          padding:"0px",
          alignItems:"flex-start",
          justifyContent:"space-around",
          gap:"1rem",
          [theme.breakpoints.down("xl")]: {
            gap:"0.5rem",
          },
          "& .MuiInputBase-input": {
            padding: "0.5rem",
            fontSize: "14px",
          },
          "& .block":{
            width:"45%",
            "& .title":{
              display:"flex",
              gap:"0.5rem",
              marginBottom:"0.5rem",
              "& .text_style":{
                fontSize:"13px",
              },
            },
            "& .date_picker":{
              width:"100%",
            },
            "& .check_style":{
              display:"flex",
              justifyContent:"flex-end",
              "& .MuiFormControlLabel-label": {
                fontSize: "12px",
              },
            }
          },
        },
      },
      "& .options": {
        padding: "0 1rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        "& .radio_group": {
          width: "75%",
          "& .MuiFormControlLabel-root": {
            margin: "0 1.5rem 0 0.05rem",
          },
          "& .MuiTypography-root": {
            fontSize: "16px",
            [theme.breakpoints.down("xl")]: {
              fontSize: "14px",
            },
          },
          "& .MuiRadio-root": {
            padding: "0.5rem 0.4rem 0.5rem 0rem",
            "& svg": {
              fontSize: "1.4rem",
              [theme.breakpoints.down("xl")]: {
                fontSize: "1.2rem",
              },
            },
          },
        },
      },
      "& .content": {
        padding: "0 0.6rem 0 1rem",
        height:
          content === "image"
            ? schedule === "yes"
              ? "151px"
              : "195px"
            : schedule === "yes"
            ? "111px"
            : "156px",
        maxHeight:
          content === "image"
            ? schedule === "yes"
              ? "151px"
              : "195px"
            : schedule === "yes"
            ? "111px"
            : "156px",
        // overflowY: "scroll",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        gap: "1rem",
        [theme.breakpoints.down("xl")]: {
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        },
        [theme.breakpoints.down("lg")]: {
          gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
        },
        "& .block": {
          position: "relative",
          width: "100%",
          height: "120px",
          "& .items": {
            width: "100%",
            height: "120px",
            border: "1px solid #E5E5E5",
            borderRadius: "4px",
            position: "relative",
            "&:hover .img_style:hover": {
              backgroundColor: "#000000",
              filter: "brightness(80%)",
              opacity: "0.4",
            },
            "&:hover .preview_text": {
              visibility: "visible",
            },
            "& .img_style": {
              cursor: "pointer",
              objectFit: "cover",
              height: "120px",
              opacity: "0.8",
            },
            "& .preview_text": {
              position: "absolute",
              color: "#FFFFFF",
              fontSize: "12px",
              fontWeight: "500",
              left: "50%",
              top: "50%",
              transform: "translate(-50%,-50%)",
              visibility: "hidden",
              cursor: "pointer",
              [theme.breakpoints.down("xl")]: {
                fontSize: "12px",
              },
              [theme.breakpoints.down("lg")]: {
                fontSize: "9px",
              },
            },
          },
          "& .MuiCheckbox-root": {
            padding: 0,
          },
          // "& .MuiSvgIcon-root": {
          //   color: "#FFFFFF",
          // },
          // "& .Mui-checked": {
          //   "& .MuiSvgIcon-root": {
          //     // background: "#FFFFFF",
          //     color: "#27AE60",
          //   },
          // },
          "& .check_style": {
            position: "absolute",
            top: "4px",
            left: "4px",
            zIndex: "2",
          },
        },
      },
    },
  },
  "& .actions": {
    boxShadow: "0px 0px 12px 0px #0000001F",
    padding: "0.5rem 1rem",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "1rem",
    "& .right_actions": {
      display: "flex",
      gap: "1rem",
      "& .back_btn": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0.5rem 1rem",
        "& .bk_btn_text": {
          color: "#787575",
          fontWeight: "500",
          fontSize: "14px",
        },
      },
      "& .Mui-disabled": {
        color: "#787575",
      },
      "& .publish_btn": {
        background: "#253A6A",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0.5rem 1rem",
        borderRadius: "6px",
        "& .pb_btn_text": {
          fontWeight: "500",
          fontSize: "14px",
        },
      },
    },
  },
  "& .alert_container": {
    position: "absolute",
    left: "0%",
    top: "1px",
    width: "100%",
    transform: "translate(0%,0%)",
  },
}));

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    // backgroundColor: "lightblue", // Change the background of the dialog
    borderRadius: "15px", // Add custom border radius
  },
  "& .MuiPickersToolbar-content": {
    display: "flex",
    // background: "red",
    alignItems: "flex-end",
    "& .MuiDateTimePickerToolbar-dateContainer": {
      height: "100%",
    },
    "& .MuiDateTimePickerToolbar-timeContainer": {
      alignSelf: "flex_end",
      "& .MuiTypography-h3": {
        fontSize: "36px",
      },

      "& .MuiDateTimePickerToolbar-timeDigitsContainer": {
        display: "flex",
        "& .MuiButtonBase-root": {
          alignSelf: "flex-end",
        },
        "& .MuiDateTimePickerToolbar-separator": {
          alignSelf: "flex-end",
        },
      },
      "& .MuiDateTimePickerToolbar-ampmSelection": {
        display: "flex",
        flexDirection: "column",
        "& .MuiButtonBase-root": {
          display: "flex",
          alignItems: "flex-end",
        },
        "& .MuiDateTimePickerToolbar-ampmLabel": {
          fontSize: "14px",
          alignSelf: "flex-end",
        },
      },
    },
  },
}));

const pattern = /\.mp4/i;
const patternAudio = /\.mp3/i;

let platforms = [
  {
    id: 1,
    label: "Facebook",
    value:"facebook",
    icon:<FacebookIcon style={{height:18,width:18}}/>
  },
  {
    id: 2,
    label: "Instagram",
    value:"instagram",
    icon:<InstagramIcon style={{height:18,width:18}}/>
  },
  // {
  //   id: 4,
  //   label: "YouTube",
  //   value:"youtube",
  //   icon:<YoutubeIcon style={{height:18,width:18}}/>
  // },
];

const PublishContentDialog = ({
  open,
  onClose,
  attachments,
  caption,
  pageName,
  taskId,
}) => {
  const { showAlert } = useContext(AlertContext);
  const { width } = useWindowDimensions();
  const [openPreview, setOpenPreview] = useState(false);
  const [value, setValue] = useState("image");
  const [imageFiles, setImageFiles] = useState([]);
  const [videoFiles, setVideoFiles] = useState([]);
  const [reelsFiles, setReelsFiles] = useState([]);
  const [audioFiles, setAudioFiles] = useState([]);
  const [checkedItemSequence, setCheckedItemSequence] = useState([]);
  const [fileIds, setFileIds] = useState([]);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [selectedPreview, setSelectedPreview] = useState("");
  const [openFinalConfirm, setOpenFinalConfirm] = useState(false);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [disableConfirmButton, setDisableConfirmButton] = useState(false);
  const [openThumbnailDialog, setOpenThumbnailDialog] = useState(false);
  const [selectedPlatforms, setSelectedPlatforms] = useState([...platforms]);
  const [customizePost, setCustomizePost] = useState(false);
  const [platformSelected, setPlatformSelected] = useState("facebook");
  const [schedulePost, setSchedulePost] = useState(false);
  const [descriptions, setDescriptions] = useState({
    facebook: "",
    instagram: "",
    youtube:""
  });
  const [scheduleDates, setScheduleDates] = useState({
    facebook: null,
    instagram: null,
    youtube:null
  });
  const [titles, setTitles] = useState({
    facebook: "",
    youtube:""
  });
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef(null);
  const uniqueFilesRef = useRef(new Set());

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (open) {
      setSelectedPlatforms([...platforms]);
      setPlatformSelected(platforms[0].value);
    }
  }, [open]);

  const handleNextForVideo = async () => {
    // customizePost check
    if (customizePost) {
      let flag = false;
      selectedPlatforms.forEach((platform) => {
        if (descriptions[platform.value] === "") {
          showAlert(`Description is required for ${platform.label}`, "warning");
          flag = true;
          return;
        }
      });
      selectedPlatforms.forEach((platform) => {
        if (platform.value !== "instagram" && titles[platform.value] === "") {
          showAlert(`Title is required for ${platform.label}`, "warning");
          flag = true;
          return;
        }
      });
      if (flag) {
        return;
      }
    } else {
      if (descriptions[selectedPlatforms[0].value] === "") {
        showAlert("Description is required", "warning");
        return;
      }
      if(value === "video" && (platformSelected === "instagram" ? titles[selectedPlatforms[1]?.value] === "" : titles[selectedPlatforms[0].value] === "")) {
        showAlert("Title is required", "warning");
        return;
      }
    }
    // schedulePost check
    if(schedulePost){
      let flag = false;
      selectedPlatforms.forEach((platform) => {
        if (scheduleDates[platform.value] === null) {
          showAlert(`Schedule date is required for ${platform.label}`,"warning");
          flag = true;
          return;
        }
      });
      if (flag) {
        return;
      }
    }
    if (videoFiles.length > 0) {
      setOpenThumbnailDialog(true);
    }
  };

  const handleClickClosePreview = () => {
    setOpenPreview(false);
  };

  const handleClose = () => {
    onClose();
  };

  const handleDialogCloseFinalConfirm = () => {
    setOpenFinalConfirm(false);
  };

  const handleDialogCloseMessageDialog = () => {
    setOpenMessageDialog(false);
  };
  const onEmojiClick = (emojiData) => {
    const emoji = emojiData.emoji;
    // setDescription((prev) => prev + emoji);
    setDescriptions((prev) => ({
      ...prev,
      [platformSelected]: prev[platformSelected] + emoji,
    }));
  };
  const handleRadioChange = (event) => {
    if (value === "video") {
      videoFiles.map((val) => {
        val.checked = false;
        return val;
      });
      setVideoFiles(videoFiles);
    }
    if (value === "reel") {
      reelsFiles.map((val) => {
        val.checked = false;
        return val;
      });
      setReelsFiles(reelsFiles);
    }
    setFileIds([]);
    setThumbnailUrl("");
    setValue(event.target.value);
  };

  const handlePreview = (item) => {
    setSelectedPreview(item?.pk);
    setOpenPreview(true);
  };

  const handlePublish = async () => {
    setDisableConfirmButton(true);
    let type = "";

    // type:  1- reel, 2- video, 3 - post
    // platform: 1- facebook, 2- instagram, 3- twitter, 4- youtube
    let thumbnail = thumbnailUrl;
    if (value === "image") {
      type = 3;
      if (customizePost) {
        let flag = false;
        selectedPlatforms.forEach((platform) => {
          if (descriptions[platform.value] === "") {
            showAlert(
              `Description is required for ${platform.label}`,
              "warning"
            );
            flag = true;
            return;
          }
        });
        if (flag) {
          setOpenFinalConfirm(false);
          return;
        }
      } else {
        if (descriptions[selectedPlatforms[0].value] === "") {
          showAlert("Description is required", "warning");
          setOpenFinalConfirm(false);
          return;
        }
      }
      if (schedulePost) {
        let flag = false;
        selectedPlatforms.forEach((platform) => {
          if (scheduleDates[platform.value] === null) {
            showAlert(
              `Schedule date is required for ${platform.label}`,
              "warning"
            );
            flag = true;
            return;
          }
        });
        if (flag) {
          setOpenFinalConfirm(false);
          return;
        }
      }
    } else if (value === "video" || value === "reel") {
      if (thumbnailUrl?.startsWith("data:image")) {
        try {
          thumbnail = await uploadGeneratedThumbnail(
            thumbnailUrl,
            taskId,
            selectedPlatforms[0].value
          );
        } catch (err) {
          showAlert(
            "Error uploading generated thumbnail: " + err.message,
            "error"
          );
          setDisableConfirmButton(false);
          setOpenFinalConfirm(false);
          return;
        }
      }
      type = value === "video" ? 2 : 1;
    }

    if (selectedPlatforms.some((item) => item.value === "facebook")) {
      const { error } = await publishContent(
        fileIds,
        type,
        customizePost
          ? descriptions.facebook
          : descriptions[selectedPlatforms[0].value],
        taskId,
        titles.facebook === "" ? titles.youtube : titles.facebook,
        schedulePost ? scheduleDates.facebook[`${`$d`}`] : null,
        1, // platform = facebook
        thumbnail
      );

      if (error) {
        showAlert(error, "error");
        setDisableConfirmButton(false);
        handleDialogCloseFinalConfirm();
        return;
      }
    }

    if (selectedPlatforms.some((item) => item.value === "instagram")) {
      const { error } = await publishContent(
        fileIds,
        type === 3 ? 3 : 1,
        customizePost
          ? descriptions.instagram
          : descriptions[selectedPlatforms[0].value],
        taskId,
        "", // title
        schedulePost ? scheduleDates.instagram[`${`$d`}`] : null,
        2, // platform = instagram
        thumbnail
      );

      if (error) {
        showAlert(error, "error");
        setDisableConfirmButton(false);
        handleDialogCloseFinalConfirm();
        return;
      }
    }

    if (selectedPlatforms.some((item) => item.value === "youtube")) {
      const { data, error } = await getYoutubeAuth(taskId);

      if (data) {
        if (data?.auth_url) {
          // Open popup window with specific dimensions
          const width = 500;
          const height = 550;
          const left = (window.innerWidth - width) / 2;
          const top = (window.innerHeight - height) / 2 + 50;

          const authWindow = window.open(
            data.auth_url,
            "YouTube Authorization",
            `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,status=no,menubar=no`
          );

          // Set up polling to check authentication status
          const checkAuthStatus = setInterval(async () => {
            try {
              const statusCheck = await getYoutubeAuthStatus(taskId);
              if (statusCheck.data && statusCheck.data.authenticated || authWindow.closed) {
                clearInterval(checkAuthStatus);
                // if (!authWindow.closed) {
                authWindow.close();
                // }

                // Auth successful, publish content
                if (statusCheck.data.authenticated) {
                  const { error } = await publishYoutubeContent(
                    fileIds,
                    type,
                    customizePost
                      ? descriptions.youtube
                      : descriptions[selectedPlatforms[0].value],
                    taskId,
                    titles.youtube === "" ? titles.facebook : titles.youtube,
                    schedulePost && scheduleDates.youtube
                      ? scheduleDates.youtube[`$d`]
                      : null,
                    thumbnail
                  );

                  if (error) {
                    showAlert(error, "error");
                    setDisableConfirmButton(false);
                    handleDialogCloseFinalConfirm();
                    return;
                  }

                  // Only show success message once publishing is complete
                  setOpenThumbnailDialog(false);
                  setDisableConfirmButton(false);
                  handleDialogCloseFinalConfirm();
                  setOpenMessageDialog(true);
                  setTimeout(() => {
                    handleDialogCloseMessageDialog();
                  }, 2000);
                }
              }
            } catch (e) {
              console.error("Error in auth check:", e);
            }
          }, 1000);

          return;
        } else {
          const { error } = await publishYoutubeContent(
            fileIds,
            type,
            customizePost
              ? descriptions.youtube
              : descriptions[selectedPlatforms[0].value],
            taskId,
            titles.youtube === "" ? titles.facebook : titles.youtube,
            schedulePost ? scheduleDates.youtube[`${`$d`}`] : null,
            thumbnail
          );
          if (error) {
            showAlert(error, "error");
            setDisableConfirmButton(false);
            handleDialogCloseFinalConfirm();
            return;
          }
        }
      } else if (error) {
        showAlert(error, "error");
        setDisableConfirmButton(false);
        handleDialogCloseFinalConfirm();
        return;
      }
    }

    setOpenThumbnailDialog(false);
    setDisableConfirmButton(false);
    handleDialogCloseFinalConfirm();
    setOpenMessageDialog(true);
    setTimeout(() => {
      handleDialogCloseMessageDialog();
    }, 2000);
  };

  const setAttachmentsCategory = () => {
    let images = [];
    let videos = [];
    let reels = [];
    uniqueFilesRef.current.clear();
    selectedPlatforms.forEach((platform) => {
      attachments?.[platform.value]?.forEach((item) => {
        if (item?.approved_status !== 2) return;

        item.checked = false;
        if (pattern.test(item?.file_urls[0])) {
          videos.push(item);
          reels.push(item);
        }
        else if (patternAudio.test(item?.file_urls[0])) {
          setAudioFiles((prev) => [...prev, item]);
        }
        else {
          if (!uniqueFilesRef.current.has(item.pk)) {
            uniqueFilesRef.current.add(item.pk);
            images.push(item);
          }
        }
      });
    });
    setImageFiles(images);
    setVideoFiles(videos);
    setReelsFiles(reels);

    let defaultItem = null;

    if (value === "image" && images.length) {
      defaultItem = images[0];
    } else if (value === "video" && videos.length) {
      defaultItem = videos[0];
    } else if (value === "reel" && reels.length) {
      defaultItem = reels[0];
    }

    if (defaultItem) {
      defaultItem.checked = true;
      setFileIds([defaultItem.pk]);
      setSelectedPreview(defaultItem.pk);
      setOpenPreview(true); 
    }
  };

  const handleCheckBoxClick = (e, item, type) => {
    e.stopPropagation();
    let contains = type !== "thumbnail" ? fileIds.includes(item?.pk) : false;

    if (value !== "image" && !contains) {
      if (type === "thumbnail") {
        if (thumbnailUrl === item?.file_urls[0]) {
          setThumbnailUrl("");
        } else {
          setThumbnailUrl(item?.file_urls[0]);
        }
        return;
      }

      if (fileIds.length > 0) {
        setWarningMessage("You can select only one video file");
        setTimeout(() => {
          setWarningMessage("");
        }, 2200);
        return;
      }
    }

    const files = value === "image" ? imageFiles : videoFiles;
    files.forEach((val) => {
      if (item?.pk === val?.pk) {
        item.checked = !contains;
      }
    });
    if (contains) {
      let newFileids = fileIds.filter((val) => val !== item?.pk);
      setFileIds(newFileids);
    } else {
      if (type !== "thumbnail") {
        setFileIds((prevField) => [...prevField, item?.pk]);
      }
    }
  };

  const handleWarningClose = () => {
    setWarningMessage("");
  };

  const handlePlatformChange = (value) => {
    setSelectedPlatforms(value);
    if (value.length > 0) {
      setPlatformSelected(value[0].value);
    }
    if (value.some((p) => p.value === "youtube")) {
      setValue("video");
    }
  }

  const handleTitleChange = (platform, newValue) => {
    setTitles((prev) => ({
      ...prev,
      [platform]: newValue,
    }));
  }

  const handleDescriptionChange = (platform, newValue) => {
    setDescriptions((prev) => ({
      ...prev,
      [platform]: newValue,
    }));
  };

  const handleScheduleDate = (platform,value) => {
    setScheduleDates((prev) => ({
      ...prev,
      [platform]: value,
    }));
  }

  const handleSameScheduleDate = (platform) => {
    setScheduleDates((prev) => ({
      ...prev,
      [platform]: scheduleDates?.[`${selectedPlatforms[0]?.value}`],
    }));
  }

  useEffect(() => {
    if (!selectedPlatforms.length) return;
    setImageFiles([]);
    setVideoFiles([]);
    setAudioFiles([]);
    setReelsFiles([]);
    setFileIds([]);
    setSelectedPreview("");
    setDescriptions((prev) => ({
      ...prev,
      [selectedPlatforms[0].value]: caption,
    }));
    if (attachments) {
      setAttachmentsCategory();
    }
  }, [attachments,selectedPlatforms]);

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth={
        width <= 1200 ? "sm" : width > 1200 && width <= 1536 ? "md" : "md"
      }
    >
      <Container content={value} schedule={schedulePost}>
        <div className="top_section">
          <div className="heading">
            <Typography className="text_style">Preview & Publish</Typography>
          </div>
          <div className="content_info">
            <div className="page_info">
              <Typography className="page_text">{pageName?.name}</Typography>
            </div>
            <div className="platform_select">
              <AutoCompleteMultiPlatformSelect
                size="small"
                variant="outlined"
                text="platform"
                color="secondary"
                value={selectedPlatforms}
                options={platforms}
                autoComplete="true"
                label="Select Platform *"
                onChange={handlePlatformChange}
                fontSize="14px"
                Type={2}
                popupIcon={<DropDownIcon />}
              />
            </div>

            <div className="options">
              <RadioGroup
                row
                name="controlled-radio-buttons-group"
                className="radio_group"
                value={value}
                onChange={handleRadioChange}
              >
                {!selectedPlatforms.some((p) => p.value === "youtube") && (
                <FormControlLabel
                  value="image"
                  control={<Radio color="secondary" />}
                  label="Image"
                />
                )}
                {selectedPlatforms.some((p) => p.value !== "instagram") && (
                  <FormControlLabel
                    value="video"
                    control={<Radio color="secondary" />}
                    label="Video"
                  />
                )}
                {!selectedPlatforms.some((p) => p.value === "youtube") && (
                <FormControlLabel
                  value="reel"
                  control={<Radio color="secondary" />}
                  label="Reel"
                />
                )}
              </RadioGroup>
            </div>
            
            <Accordion className="accordion_container" expanded={true}>
              <AccordionSummary
                expandIcon={
                  <AntSwitch
                    inputProps={{ "aria-label": "ant design" }}
                    onChange={(e) => {
                      setCustomizePost(e.target.checked);
                      setPlatformSelected(selectedPlatforms[0]?.value);
                    }}
                    checked={customizePost}
                  />
                }
                className="summary"
              >
                <Typography component="span">Customize Post</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {customizePost && (
                  <div className="acr_btn_container">
                    {selectedPlatforms?.map((item) => {
                      return (
                        <Button
                          variant="text"
                          size="small"
                          startIcon={item?.icon}
                          className={`acr_btn ${
                            platformSelected === item.value ? "selected" : ""
                          }`}
                          onClick={() => {
                            setPlatformSelected(item?.value);
                          }}
                        >
                          {item?.label}
                        </Button>
                      );
                    })}
                  </div>
                )}
                <div className="caption_container">
                  {value === "video" &&
                    (customizePost
                      ? platformSelected !== "instagram"
                      : selectedPlatforms.some(
                          (p) => p.value !== "instagram"
                        )) && (
                      <CustomTextField
                        value={titles[platformSelected === "instagram" ? selectedPlatforms[1]?.value : platformSelected]}
                        name="title"
                        label="Enter title"
                        variant="outlined"
                        color="secondary"
                        onChange={(e) => handleTitleChange(platformSelected === "instagram" ? selectedPlatforms[1]?.value : platformSelected,e.target.value)}
                        sx={{ width: "100%",marginBottom:"0.5rem" }}
                        radius="4px"
                        required
                      />
                    )}
                  <TextareaAutosize
                    minRows={3}
                    style={{
                      width: "100%",
                    }}
                    name="igDescription"
                    value={descriptions[platformSelected]}
                    placeholder={
                      platformSelected === "facebook"
                        ? "Enter caption *"
                        : "Enter description *"
                    }
                    onChange={(e) =>
                      handleDescriptionChange(platformSelected, e.target.value)
                    }
                    required={true}
                  />
                  {!showEmojiPicker && (
                    <CustomButton
                      onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                      sx={{
                        minWidth: "40px",
                        width: "40px",
                        padding: "0",
                        ml: "auto",
                      }}
                    >
                      😊
                    </CustomButton>
                  )}
                  {showEmojiPicker && (
                    <Box
                      sx={{
                        "& h2": {
                          fontSize: "14px !important",
                        },
                      }}
                      ref={emojiPickerRef}
                    >
                      <EmojiPicker
                        searchDisabled
                        onEmojiClick={onEmojiClick}
                        theme="light"
                        className="emoji-picker-container"
                        width={"100%"}
                        style={{
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "5px",
                          width: "100%",
                        }}
                      />
                    </Box>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion className="schedulerAccordion" expanded={schedulePost}>
              <AccordionSummary
                expandIcon={
                  <AntSwitch
                    inputProps={{ "aria-label": "ant design" }}
                    onChange={(e) => {
                      setSchedulePost(e.target.checked);
                    }}
                    checked={schedulePost}
                  />
                }
                className="summary "
              >
                <Typography component="span">Schedule Post</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="scheduler_container">
                  {selectedPlatforms?.map((item, idx) => {
                    return (
                      <div className="block" key={item?.id}>
                        <div className="title">
                          {item?.icon}
                          <Typography className="text_style">
                            {item?.label}
                          </Typography>
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDateTimePicker
                            color="secondary"
                            value={scheduleDates?.[`${item?.value}`]}
                            onChange={(v) => handleScheduleDate(item?.value, v)}
                            slots={{
                              dialog: StyledDialog,
                            }}
                            className="date_picker"
                            disablePast
                          />
                        </LocalizationProvider>
                        {idx > 0 && (
                          <div className="check_style">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(e) =>
                                    handleSameScheduleDate(item?.value)
                                  }
                                  size="small"
                                />
                              }
                              label={`Same as ${selectedPlatforms[0]?.label}`}
                              checked={
                                scheduleDates?.[`${item?.value}`] ===
                                  scheduleDates?.[
                                    `${selectedPlatforms[0]?.value}`
                                  ] &&
                                scheduleDates?.[`${item?.value}`] !== null
                              }
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </AccordionDetails>
            </Accordion>

            <div className="content">
              {value !== "image" ? (
                value === "video" ? (
                  <>
                    {videoFiles.map((item) => {
                      return (
                        <div className="block">
                          <div
                            className="items"
                            key={item?.pk}
                            onClick={() => handlePreview(item)}
                          >
                            <img
                              src={DefaultThumbnail}
                              alt="demo_img"
                              className="img_style"
                              style={{
                                width: "100%",
                                borderRadius: "4px",
                              }}
                            />
                            <Typography className="preview_text">
                              Preview Image
                            </Typography>
                          </div>
                          <Checkbox
                            checked={item?.checked}
                            onChange={(e) => handleCheckBoxClick(e, item)}
                            icon={<UncheckedIcon />}
                            checkedIcon={<CheckedIcon />}
                            color="secondary"
                            size="small"
                            className="check_style"
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  reelsFiles.map((item) => {
                    return (
                      <div className="block">
                        <div
                          className="items"
                          key={item?.pk}
                          onClick={() => handlePreview(item)}
                        >
                          <img
                            src={DefaultThumbnail}
                            alt="demo_img"
                            className="img_style"
                            style={{
                              width: "100%",
                              borderRadius: "4px",
                            }}
                          />
                          <Typography className="preview_text">
                            Preview Image
                          </Typography>
                        </div>
                        <Checkbox
                          checked={item?.checked}
                          onChange={(e) => handleCheckBoxClick(e, item)}
                          icon={<UncheckedIcon />}
                          checkedIcon={<CheckedIcon />}
                          color="secondary"
                          size="small"
                          className="check_style"
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </div>
                    );
                  })
                )
              ) : (
                imageFiles.map((item) => {
                  if (item.subcategory !== "thumbnail") {
                    return (
                      <div className="block">
                        <div
                          className="items"
                          key={item?.pk}
                          onClick={() => handlePreview(item)}
                        >
                          <img
                            src={item?.file_urls[0]}
                            alt="demo_img"
                            className="img_style"
                            style={{
                              width: "100%",
                              borderRadius: "4px",
                            }}
                          />
                          <Typography className="preview_text">
                            Preview Image
                          </Typography>
                        </div>
                        <Checkbox
                          checked={item?.checked}
                          onChange={(e) => handleCheckBoxClick(e, item)}
                          icon={<UncheckedIcon />}
                          // checkedIcon={<CheckedIcon />}
                          checkedIcon={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                backgroundColor: "#ffffff",
                                color: "#27AE60",
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {fileIds.indexOf(item?.pk) + 1}
                            </span>
                          }
                          color="secondary"
                          size="small"
                          className="check_style"
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </div>
                    );
                  }
                })
              )}
            </div>
          </div>
        </div>
        <div className="actions">
          <div className="right_actions">
            <CustomButton className="back_btn" onClick={handleClose}>
              <Typography className="bk_btn_text">Back</Typography>
            </CustomButton>
            {value !== "image" ? (
              <CustomButton
                variant="contained"
                className="publish_btn"
                onClick={handleNextForVideo}
                disabled={fileIds?.length ? false : true}
              >
                <Typography className="pb_btn_text">Next</Typography>
              </CustomButton>
            ) : (
              <CustomButton
                variant="contained"
                className="publish_btn"
                startIcon={fileIds?.length ? <PublishIcon /> : ""}
                onClick={() => setOpenFinalConfirm(true)}
                disabled={fileIds?.length ? false : true}
              >
                <Typography className="pb_btn_text">Publish</Typography>
              </CustomButton>
            )}
          </div>
        </div>
        {openThumbnailDialog && (
          <ThumbnailSelection
            open={openThumbnailDialog}
            onClose={() => {
              setOpenThumbnailDialog(false);
              setThumbnailUrl("");
            }}
            userUploadedThumbnails={imageFiles.filter(
              (item) => item.subcategory === "thumbnail"
            )}
            videoFile={videoFiles.find((v) => v?.checked) || null}
            thumbnailUrl={thumbnailUrl}
            handleCheckBoxClick={handleCheckBoxClick}
            handlePublish={() => {
              setOpenFinalConfirm(true);
              // handlePublish();
            }}
          />
        )}
        {warningMessage ? (
          <div className="alert_container">
            <Alert
              severity="warning"
              onClose={() => {
                handleWarningClose();
              }}
            >
              You can select only one video file
            </Alert>
          </div>
        ) : (
          <></>
        )}
        {openPreview ? (
          <PreviewImageVideo
            open={openPreview}
            onClose={handleClickClosePreview}
            selectedPreview={selectedPreview}
            totalAttachments={
              value === "image"
                ? imageFiles
                : value === "video"
                ? videoFiles
                : reelsFiles
            }
            type={value}
          />
        ) : (
          <></>
        )}
        {openFinalConfirm ? (
          <FinalConfirmation
            open={openFinalConfirm}
            onClose={handleDialogCloseFinalConfirm}
            onConfirm={handlePublish}
            message={"Are you sure you want to publish the post?"}
            disableConfirmButton={disableConfirmButton}
          />
        ) : (
          <></>
        )}
        {openMessageDialog ? (
          <MessageDialog
            open={openMessageDialog}
            onClose={handleDialogCloseMessageDialog}
            icon={ClockIcon}
            message={
              "Post is in progress. You will be notified once the post is successfully published."
            }
          />
        ) : (
          <></>
        )}
      </Container>
    </Dialog>
  );
};

export default PublishContentDialog;
